import React, { useState } from "react";
import { motion } from "framer-motion";
import { Github, Linkedin, Mail, Twitter, Send } from "lucide-react";

// Contact Methods
const contactMethods = [
  { name: "GitHub", icon: Github, link: "https://github.com/yesvanthraja" },
  { name: "LinkedIn", icon: Linkedin, link: "https://www.linkedin.com/in/yesvanthraja-d-7841b324a/" },
  { name: "Email", icon: Mail, link: "mailto:yeshuraja07@gmail.com" },
  { name: "Twitter", icon: Twitter, link: "https://twitter.com/yourprofile" },
];

// Floating Animation
const floatingAnimation = {
  y: [0, -5, 0],
  transition: {
    duration: 3,
    repeat: Infinity,
    repeatType: "mirror" as "mirror",
    ease: "easeInOut",
  },
};

const LetsConnect = () => {
  return (
    <section className="relative min-h-screen bg-black text-white flex flex-col items-center justify-center px-6 sm:px-10 overflow-hidden">
      {/* Background Animation */}
      <motion.div
        className="absolute inset-0 bg-gradient-to-b from-black via-gray-900 to-black"
        animate={{ opacity: [0.7, 1, 0.7] }}
        transition={{ duration: 6, repeat: Infinity, repeatType: "mirror", ease: "easeInOut" }}
      />

      {/* Floating Abstract Elements */}
      <motion.div
        className="absolute top-10 left-10 w-16 h-16 bg-gray-800 rounded-lg transform rotate-45 opacity-50"
        animate={floatingAnimation}
      />
      <motion.div
        className="absolute bottom-10 right-16 w-20 h-20 bg-gray-700 rounded-lg transform rotate-45 opacity-30"
        animate={floatingAnimation}
      />

      {/* Title Section */}
      <div className="text-center relative">
        <h2 className="text-5xl font-bold bg-gradient-to-r from-white to-gray-400 bg-clip-text text-transparent">
          Let’s Connect
        </h2>
        <p className="text-xl text-gray-400 mt-4">
          Let’s collaborate and build something exceptional.
        </p>
      </div>

      {/* Contact Methods */}
      <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-12 relative z-10">
        {contactMethods.map((contact, index) => (
          <motion.a
            key={index}
            href={contact.link}
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.2 }}
            className="flex flex-col items-center justify-center gap-3 text-gray-400 hover:text-white transition-all duration-300"
          >
            <motion.div
              className="p-5 bg-gray-800/50 border border-gray-700 rounded-full shadow-md backdrop-blur-md"
              animate={floatingAnimation}
              whileHover={{ scale: 1.2, backgroundColor: "rgba(255,255,255,0.1)" }}
            >
              <contact.icon className="w-12 h-12 text-white" />
            </motion.div>
            <span className="text-lg font-medium">{contact.name}</span>
          </motion.a>
        ))}
      </div>

      {/* Contact Form */}
      <motion.div
        className="relative bg-black border border-gray-700 backdrop-blur-lg p-8 rounded-3xl shadow-lg mt-20 w-full max-w-lg"
        whileHover={{ scale: 1.02 }}
      >
        <h3 className="text-3xl font-semibold text-center text-white">Send a Message</h3>
        <form className="mt-6 flex flex-col gap-4">
          <input
            type="text"
            placeholder="Your Name"
            className="bg-black 0 border border-gray-600 px-4 py-3 rounded-lg focus:ring-2 focus:ring-white text-white"
          />
          <input
            type="email"
            placeholder="Your Email"
            className="bg-black border border-gray-600 px-4 py-3 rounded-lg focus:ring-2 focus:ring-white text-white"
          />
          <textarea
            placeholder="Your Message"
            rows={4}
            className="bg-black border border-gray-600 px-4 py-3 rounded-lg focus:ring-2 focus:ring-white text-white"
          />
          <motion.button
            type="submit"
            whileHover={{ scale: 1.05, backgroundColor: "#ffffff", color: "#000" }}
            className="mt-4 bg-white text-black px-6 py-3 rounded-lg flex items-center justify-center gap-2 font-semibold transition"
          >
            Send Message <Send size={18} />
          </motion.button>
        </form>
      </motion.div>
    </section>
  );
};

export default LetsConnect;


// import React, { useState } from "react";
// import { motion } from "framer-motion";
// import { Github, Linkedin, Mail, Twitter, Send } from "lucide-react";

// // Contact Methods
// const contactMethods = [
//   { name: "GitHub", icon: Github, link: "https://github.com/yourprofile" },
//   { name: "LinkedIn", icon: Linkedin, link: "https://linkedin.com/in/yourprofile" },
//   { name: "Email", icon: Mail, link: "mailto:your-email@example.com" },
//   { name: "Twitter", icon: Twitter, link: "https://twitter.com/yourprofile" },
// ];

// // Floating Animation
// const floatingAnimation = {
//   y: [0, -5, 0],
//   transition: {
//     duration: 3,
//     repeat: Infinity,
//     repeatType: "mirror" as "mirror",
//     ease: "easeInOut",
//   },
// };

// const LetsConnect = () => {
//   const [hovered, setHovered] = useState(false);

//   return (
//     <section className="relative min-h-screen bg-black text-white flex flex-col items-center justify-center px-6 sm:px-10 overflow-hidden">
//       {/* Glowing Background */}
//       <motion.div
//         className="absolute inset-0 bg-gradient-to-b from-black via-black/80 to-black"
//         animate={{ opacity: [0.7, 1, 0.7] }}
//         transition={{ duration: 5, repeat: Infinity, repeatType: "mirror", ease: "easeInOut" }}
//       />

//       {/* Title Section */}
//       <div className="text-center relative">
//         <h2 className="text-5xl font-bold bg-gradient-to-r from-white via-gray-400 to-white bg-clip-text text-transparent">
//           Let’s Connect
//         </h2>
//         <p className="text-xl text-gray-400 mt-4">
//           Reach out to me and let's build something amazing together.
//         </p>
//       </div>

//       {/* Contact Methods */}
//       <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-10 relative z-10">
//         {contactMethods.map((contact, index) => (
//           <motion.a
//             key={index}
//             href={contact.link}
//             target="_blank"
//             rel="noopener noreferrer"
//             whileHover={{ scale: 1.2 }}
//             className="flex flex-col items-center justify-center gap-3 text-gray-300 hover:text-white transition-all duration-300"
//           >
//             <motion.div
//               className="p-5 bg-gray-800/50 border border-gray-700 rounded-full shadow-md"
//               animate={floatingAnimation}
//             >
//               <contact.icon className="w-12 h-12" />
//             </motion.div>
//             <span className="text-lg font-medium">{contact.name}</span>
//           </motion.a>
//         ))}
//       </div>

//       {/* Light Animation on Hover */}
//       <motion.div
//         className="absolute w-[500px] h-[500px] pointer-events-none transition-transform duration-100 ease-out"
//         style={{
//           background: hovered
//             ? "radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)"
//             : "transparent",
//         }}
//       />

//       {/* Contact Form */}
//       <motion.div
//         className="relative bg-white/5 border border-gray-700 backdrop-blur-sm p-8 rounded-xl shadow-lg mt-20 w-full max-w-lg"
//         whileHover={{ scale: 1.05 }}
//       >
//         <h3 className="text-3xl font-semibold text-center text-white">Send a Message</h3>
//         <form className="mt-6 flex flex-col gap-4">
//           <input
//             type="text"
//             placeholder="Your Name"
//             className="bg-gray-900 border border-gray-600 px-4 py-3 rounded-lg focus:ring-2 focus:ring-green-400 text-white"
//           />
//           <input
//             type="email"
//             placeholder="Your Email"
//             className="bg-gray-900 border border-gray-600 px-4 py-3 rounded-lg focus:ring-2 focus:ring-green-400 text-white"
//           />
//           <textarea
//             placeholder="Your Message"
//             rows={4}
//             className="bg-gray-900 border border-gray-600 px-4 py-3 rounded-lg focus:ring-2 focus:ring-green-400 text-white"
//           />
//           <motion.button
//             type="submit"
//             whileHover={{ scale: 1.1 }}
//             className="mt-4 bg-green-500 text-white px-6 py-3 rounded-lg flex items-center justify-center gap-2 font-semibold hover:bg-green-400 transition"
//           >
//             Send Message <Send size={18} />
//           </motion.button>
//         </form>
//       </motion.div>
//     </section>
//   );
// };

// export default LetsConnect;